import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/zamzam/web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/var/www/zamzam/web/src/components/common/index.ts");
